import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/xailingSchedule'

export const routScheduleService = {
	search,
	getItem,
	saveItem,
	updateItem,
	deleteItem,
};

function search(data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', {data:data, showAlert:false})
}

function getItem(id) {
	return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data:data});
}

function updateItem(id, data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data:data});
}

function deleteItem(id, fbDB) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}